import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserTimeFormat from '../../components/user-time-format/connected';
import UserDateFormat from '../../components/user-date-format/index';
import style from './note-tooltip-time.module.less';

const IconMessageColumn = ({ createdDateTime = '' }) => {
  if (!createdDateTime) {
    return null;
  }
  return (
    <div className={style['node-tooltip-time']}>
      <FormattedMessage defaultMessage='Created' description='noteTooltipTime.created' id='fAQ/o1' />
      &nbsp;
      <UserDateFormat value={createdDateTime} />
      &nbsp;
      <span className={style['date-separator']}>&bull;</span>
      <UserTimeFormat value={createdDateTime} />
    </div>
  );
};

IconMessageColumn.propTypes = {
  createdDateTime: PropTypes.string,
};

export default IconMessageColumn;
